import { Icon } from '@iconify/react'
import { Avatar, Box, Button, Card, CardActions, CardContent, Checkbox, Chip, Divider, FormControl, FormControlLabel, FormGroup, Grid, Hidden, IconButton, InputLabel, MenuItem, Rating, Select, Tab, TextField, Tooltip, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Controller, useForm } from 'react-hook-form'
import { useGetVendorCardQuery, usePostVendorSaveMutation } from '../../store/api/vendorApi'
import { useNavigate, useParams } from 'react-router-dom'
import { onReadSup, onReviseSup, updateReviseId, updateReviseIsUpdate } from '../../store/slice/otherSlice'
import { setStep } from '../../store/slice/buttonSlice'
import { Edit } from '@mui/icons-material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { DataGrid } from '@mui/x-data-grid'
import { dataColumn } from '../../components/DataColumn'
import { TextForm } from '../../components/TextBox'
import SelectForm from '../../components/SelectBox/SelectForm'
import PhoneTextForm from '../../components/TextBox/PhoneTextForm'
import { useEffect } from 'react'
import { vendorApprovalStatusArray, vendorStatusArray } from '../../constDatas/constDatas'
import { showErrorToast, showSuccessToast } from '../../constToast/constToast'
import { hideSaveDialog } from '../../store/slice/dialogSlice'
import SaveDialog from '../../components/Dialog/SaveDialog'
import moment from 'moment'
import DateForm from '../../components/SelectBox/DateForm'
import RadioVendorSupplier from '../../components/Checkbox/RadioVendorSupplier'
import VendorRFQ from './VendorCompanyCardComponent/VendorRFQ'
import ApproveDialog from '../../components/Dialog/ApproveDialog'
import HoldDialog from '../../components/Dialog/HoldDialog'
import RejectDialog from '../../components/Dialog/RejectDialog'
import LogDialog from '../../components/Dialog/LogDialog'
import VendorBank from './VendorCompanyCardComponent/VendorBank'
import UploadPhotoVendor from '../../components/UploadPhoto/UploadPhotoVendor'
import InfoIcon from '@mui/icons-material/Info';
import TextPhone from '../../components/TextBox/TextPhone'

export default function VendorCard() {
  const userInfo = useSelector(state => state.mainToCard.userInfo)
  const { dataId } = useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useGetVendorCardQuery(dataId);


  React.useLayoutEffect(() => {
    if (!isLoading) {
      if (userInfo?.userType === 0 && userInfo?.vendorId == dataId) {
        navigate(`/vendors/${userInfo?.vendorId}`)
      } else if (userInfo?.userType === 1) {

      }
      else {
        navigate(`/403`)
      }
    }

  }, [userInfo, dataId, navigate, isLoading])



  const [postVendor] = usePostVendorSaveMutation();
  const { handleSubmit, control, formState: { errors }, reset, watch, setValue } = useForm({ mode: 'onBlur' });

  const [imageURL, setImageURL] = useState('');
  const [logoPost, setLogoPost] = useState(null)

  const [currencyDisabled, setCurrencyDisabled] = useState(false)
  const [checkLogoIsDeleted, setcheckLogoIsDeleted] = useState(false)
  const [typeAttachment, setTypeAttachment] = useState(0)
  const [bankAccounts, setBankAccounts] = useState([])
  const [tabValue, setTabVelue] = React.useState('1');
  const approvalStatusName = vendorApprovalStatusArray.find(item => item.approvalStatusId === data?.data?.header?.approveStatus)?.approvalStatusName
  const statusName = vendorStatusArray.find(item => item.statusId === data?.data?.header?.status)?.statusName

  // DIFF
  const [differences, setDifferences] = useState({});
  const [previousValues, setPreviousValues] = useState({});


  useEffect(() => {
    const header = data?.data?.header;
    const headerPrevious = data?.data?.headerPrevious;
    reset({
      ...header,
      companyRegistrationDate: new Date()
    })

    const { diff, previous } = findDifferences(header, headerPrevious);
    setDifferences(diff);
    setPreviousValues(previous);
  }, [reset, data])


  useEffect(() => {
    if (!isLoading && data) {
      setImageURL(data?.data?.header?.logo)
      setLogoPost(data?.data?.header?.attachmentLogo)
    }
  }, [data, isLoading, setValue])

  useEffect(() => {
    if (checkLogoIsDeleted) {
      setTypeAttachment(2)
    } else { setTypeAttachment(0) }
  }, [checkLogoIsDeleted])

  const dispatch = useDispatch()

  const handleRevise = () => {
    navigate('/supplier-evaluation')
    dispatch(onReviseSup())
    dispatch(updateReviseId(watch('revisionVendorId') || 0))
    if (watch('isUpdate')) {
      dispatch(updateReviseIsUpdate(true))
    } else {
      dispatch(updateReviseIsUpdate(false))
    }
    dispatch(setStep(0))
  }
  const handleReadonlyEvaluation = () => {
    navigate('/supplier-evaluation')
    dispatch(onReviseSup())
    dispatch(onReadSup())
    dispatch(updateReviseId(dataId))
    dispatch(setStep(0))

  }

  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true)

  const handleBlackList = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    setDisabled(!isChecked);
    setValue('blackListDescription', '')
  };


  const getColorByValue = (ratingValue) => {
    if (ratingValue <= 3) {
      return 'red';
    } else if (ratingValue <= 5) {
      return 'orange';
    } else if (ratingValue <= 7) {
      return '#5cf045';
    } else if (ratingValue <= 10) {
      return 'green';
    }
  };
  const color = getColorByValue(watch('raiting'));
  const onSubmit = async (data) => {

    const addData = await postVendor({
      ...data,
      bankAccounts,
      reviseDate: moment(new Date()).format("YYYY-MM-DD"),
      attachmentLogo: logoPost
    })

    if (addData?.data?.data) {
      showSuccessToast('Succesfully')
    } else {
      showErrorToast('Error')
    }
    dispatch(hideSaveDialog());
  }


  const findDifferences = (currentHeader, previousHeader) => {
    const diff = {};
    const previous = {};

    for (let key in currentHeader) {
      if (currentHeader[key] !== previousHeader[key]) {
        diff[key] = true;
        previous[key] = previousHeader[key];
      }
    }

    return { diff, previous };
  };


  return (
    <>
      <Grid container spacing={3} display='flex'>
        {/* Avatar */}
        <Grid item xs={12} md={6} lg={2}>
          <Card>
            <CardContent>
              <Box sx={{ alignItems: 'center', display: 'flex', flexDirection: 'column', textAlign: 'center' }}>

                <Avatar src={imageURL || ''} sx={{ height: 90, width: 90 }} />
                <h2>{data?.data?.header?.vendorName}</h2>

                <Box display='flex' alignItems='center'>
                  <span style={{ marginRight: 5 }}>{data?.data?.header?.vendorCode}</span>

                  <IconButton size='small' onClick={handleReadonlyEvaluation} sx={{ pl: 0, m: 0 }}>
                    <Icon icon="icon-park:speed-one" width='25px' height='25px' />
                  </IconButton>
                </Box>

              </Box>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: 'flex', justifyContent: 'center' }}>
              <UploadPhotoVendor label='Logo' setUrl={setImageURL}
                setIsDeleted={setcheckLogoIsDeleted} setLogoPost={setLogoPost}
                typeAttachment={typeAttachment} />
            </CardActions>
          </Card>
        </Grid>

        {/* Detail */}
        <Grid item xs={12} md={6} lg={3.5}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} textAlign='center'>
                  <Typography variant=" h6">
                    Revise No
                  </Typography>
                  <Typography variant="subtitle2">
                    <Chip size="small" sx={{ borderRadius: "5px" }} variant="outlined" label={`${(data?.data?.header?.reviseNo)?.toString()}`} />
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} textAlign='center'>
                  <Typography variant=" h6">
                    Revise Date
                  </Typography>
                  <Typography variant="subtitle2">
                    <Chip size="small" sx={{ borderRadius: "5px" }} variant="outlined" label={`${moment(data?.data?.header?.reviseDate).format("YYYY-MM-DD")}`} />
                  </Typography>

                </Grid>

                <Grid item xs={12} md={6} textAlign='center' >
                  <Typography variant=" h6">
                    Approval Status
                  </Typography>
                  <Typography variant="subtitle2">
                    <Chip size="small" sx={{ borderRadius: "5px" }} variant="outlined" label={`${approvalStatusName}`} />
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6} textAlign='center'>
                  {userInfo?.userType === 1 ? <>
                    <Typography variant=" h6">
                      Status
                    </Typography>
                    <Typography variant="subtitle2">
                      <Chip size="small" sx={{ borderRadius: "5px" }} variant="outlined" label={`${statusName}`} />
                    </Typography>
                  </> : <></>}
                </Grid>

                <Grid item xs={12} mt={2}>
                  <Divider />
                </Grid>

                <Grid item xs={12} md={8}  >
                  <Grid container display='flex' alignItems='center' textAlign='center'>
                    <Grid xs={12}>
                      {userInfo?.userType === 1 ? <Box display='flex' alignItems='center'>
                        <Typography variant='subtitle2' sx={{ pr: 2, pt: 0.4 }}>Rating {watch('raiting')}</Typography>
                        <Controller
                          name="rating"
                          control={control}
                          defaultValue={0}
                          render={({ field }) => (
                            <Rating
                              name="rating"
                              size="medium"
                              value={field.value}
                              onChange={(event, newValue) => {
                                field.onChange(newValue);
                              }}
                              max={10}
                              style={{ color: color }}
                            />
                          )}
                        />
                      </Box> : <></>}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={4}  >
                  <Grid container display='flex' alignItems='center' textAlign='center'>
                    <Grid xs={12}>
                      <Button onClick={handleRevise} variant="contained" color="secondary" size='small' endIcon={<Edit />} disabled={!(approvalStatusName === 'Approved')}>
                        Revise
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>


              </Grid>
            </CardContent>

            <Divider />


          </Card>

          {/* Black List */}
          {userInfo?.userType === 1 ? <>
            <Box display='flex' mt={2}>
              <FormGroup>
                <FormControlLabel
                  control={<Checkbox
                    checked={checked}
                    onChange={handleBlackList}
                  />} label="Black List" />
              </FormGroup>
              <Box width='100%'>
                <TextForm label='Black List' dynamicField='blackListDescription'
                  control={control} errors={errors}
                  required={false} disabled={disabled}
                  multiline={true} rows={3.5} min={3} max={100}
                />
              </Box>
            </Box>
          </> : <Hidden />}
        </Grid >

        {/* Grids */}
        <Grid item xs={12} md={12} lg={5.5}>
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabValue}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={(e, newValue) => setTabVelue(newValue)} aria-label="lab API tabs example">
                  <Tab label="User Details" value="1" />
                  <Tab label="Bank Details" value="2" />
                  <Tab label="Business Categories" value="3" />
                  {userInfo?.userType === 1 ? <></> : <Tab label="RFQ " value="4" />}
                </TabList>
              </Box>
              <TabPanel value="1">
                <Box sx={{ height: 240, width: '100%' }}>
                  <DataGrid
                    rows={data?.data?.vendorUsers || []}
                    columns={columns2}
                    getRowId={row => row.id}
                    hideFooter
                    rowHeight={30}
                  />
                </Box>
              </TabPanel>
              <TabPanel value="2">
                <Box sx={{ height: 240, width: '100%' }}>
                  <VendorBank vendorId={dataId} isLoading={isLoading} data={data} tableData={bankAccounts} setTableData={setBankAccounts} country={watch('country')} />
                </Box>
              </TabPanel>
              <TabPanel value="3">
                <Box sx={{ height: 240, width: '100%' }}>
                  <DataGrid
                    rows={data?.data?.itemCategories || []}
                    columns={columns1}
                    getRowId={row => row.businessCategoryId}
                    hideFooter
                    rowHeight={30}
                  />
                </Box>
              </TabPanel>
              <TabPanel value="4">
                <Box sx={{ height: 240, width: '100%' }}>
                  <VendorRFQ vendorCode={data?.data?.header?.vendorCode} />
                </Box>
              </TabPanel>

            </TabContext>
          </Box>
        </Grid>
      </Grid>


      <Grid item xs={12} sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', mt: 1, mb: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="div">
          Main Information
        </Typography>
        <Divider textAlign="left" sx={{ width: '92%' }}></Divider>
      </Grid>

      <form onSubmit={handleSubmit(onSubmit)} noValidate id='form-vendorCard'>
        <Grid container spacing={3} display='flex'>
          <Grid item xs={12} sm={6} md={2}>
            <Box display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Vendor Code' dynamicField='vendorCode'
                  control={control} errors={errors}
                  required={false} disabled={true}
                  min={3} max={50}
                />
              </Box>


              {differences.vendorCode && previousValues.vendorCode && (
                <Tooltip title={`Old value: ${previousValues.vendorCode}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm
                  label='Vendor Name'
                  dynamicField='vendorName'
                  control={control}
                  errors={errors}
                  required={false}
                  disabled={false}
                  min={3}
                  max={50}
                />
              </Box>
              {differences.vendorName && previousValues.vendorName && (
                <Tooltip title={`Old value: ${previousValues.vendorName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Tax ID' dynamicField='taxId'
                  control={control} errors={errors}
                  required={false} disabled={true}
                  min={3} max={50}
                />
              </Box>

              {differences.taxId && previousValues.taxId && (
                <Tooltip title={`Old value: ${previousValues.taxId}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Website' dynamicField='website'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>

              {differences.website && previousValues.website && (
                <Tooltip title={`Old value: ${previousValues.website}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box display='flex'>
              <Box flexGrow={1}>
                <Controller
                  name='emailAddress'
                  control={control}
                  defaultValue=""
                  rules={{
                    required: {
                      value: false,
                      message: 'This field is required',
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: 'Invalid email address',
                    },
                  }}
                  render={({ field }) => (
                    <TextField
                      fullWidth
                      type='email'
                      {...field}
                      size='small'
                      label='Email'
                      error={Boolean(errors.emailAddress)}
                      helperText={errors.emailAddress ? errors.emailAddress.message : ''}
                    />
                  )}
                />
              </Box>

              {differences.emailAddress && previousValues.emailAddress && (
                <Tooltip title={`Old value: ${previousValues.emailAddress}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Contact Person' dynamicField='contactPerson'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>

              {differences.contactPerson && previousValues.contactPerson && (
                <Tooltip title={`Old value: ${previousValues.contactPerson}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='Country' id='countryCode' name='countryName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.countries} dynamicField='country' required={true} />
              </Box>

              {differences.country && previousValues.country && (
                <Tooltip title={`Old value: ${previousValues.country}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='City' dynamicField='city'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>

              {differences.city && previousValues.city && (
                <Tooltip title={`Old value: ${previousValues.city}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box>
              <SelectForm label='Currency' id='currencyCode' name='currencyCode'
                control={control} errors={errors} disabled={currencyDisabled} required={true}
                data={data?.data?.currencies} dynamicField='defaultCurrency' />
            </Box>

            {userInfo?.userType === 1 ? <>
              <Box mt={1.5}>
                <FormControl fullWidth disabled>
                  <InputLabel>Vendor Type</InputLabel>
                  <Select
                    value={watch('country') === 'AZ' ? 'local' : 'foreign'}
                    label="Vendor Type"
                    size='small'
                    sx={{
                      backgroundColor: 'hsl(0, 0%, 95%)',
                    }}
                  >
                    <MenuItem value={'local'}>Local</MenuItem>
                    <MenuItem value={'foreign'}>Foreign</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </> : <>
              <Box mt={1.5} display='flex'>
                <Box flexGrow={1}>
                  <TextForm label='Tax Office' dynamicField='taxOffice'
                    control={control} errors={errors}
                    required={false} disabled={false}
                    min={3} max={50}
                  />
                </Box>

                {differences.taxOffice && previousValues.taxOffice && (
                  <Tooltip title={`Old value: ${previousValues.taxOffice}`}>
                    <IconButton>
                      <InfoIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </>}

            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Address 1' dynamicField='address1'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={100}
                />
              </Box>

              {differences.address1 && previousValues.address1 && (
                <Tooltip title={`Old value: ${previousValues.address1}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='Payment Terms' id='analysisCode' name='analysisName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.paymentTerms} dynamicField='paymentTerms' required={true} />
              </Box>

              {differences.analysisName && previousValues.analysisName && (
                <Tooltip title={`Old value: ${previousValues.analysisName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Description' dynamicField='description'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={100}
                />
              </Box>
              {differences.description && previousValues.description && (
                <Tooltip title={`Old value: ${previousValues.description}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Postal/ZIP' dynamicField='postal_ZIP'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>


              {differences.postal_ZIP && previousValues.postal_ZIP && (
                <Tooltip title={`Old value: ${previousValues.postal_ZIP}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextForm label='Address 2' dynamicField='address2'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>

              {differences.address2 && previousValues.address2 && (
                <Tooltip title={`Old value: ${previousValues.address2}`}>
                  <IconButton>
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <TextPhone
                  control={control}
                  dynamicField="phone_Mobile"
                  label='Phone'
                  required={false}
                  errors={errors}
                  minDigits={12}
                />
              </Box>


              {differences.phone_Mobile && previousValues.phone_Mobile && (
                <Tooltip title={`Old value: ${previousValues.phone_Mobile}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='Ship Via' id='shipmentId' name='shipmentName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.shipments} dynamicField='shipVia' required={false} />
              </Box>

              {differences.shipmentName && previousValues.shipmentName && (
                <Tooltip title={`Old value: ${previousValues.shipmentName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='Delivery Terms' id='deliveryTermId' name='deliveryTermName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.deliveryTerms} dynamicField='deliveryTerms' required={false} />
              </Box>

              {differences.deliveryTermName && previousValues.deliveryTermName && (
                <Tooltip title={`Old value: ${previousValues.deliveryTermName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='With Holding Tax' id='withHoldingTaxId' name='withHoldingTaxName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.withHoldingTaxDatas} dynamicField='withHoldingTaxId' required={false} />
              </Box>

              {differences.withHoldingTaxName && previousValues.withHoldingTaxName && (
                <Tooltip title={`Old value: ${previousValues.withHoldingTaxName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <Box mt={1.5} display='flex'>
              <Box flexGrow={1}>
                <SelectForm label='Tax' id='taxId' name='taxName'
                  control={control} errors={errors} disabled={false}
                  data={data?.data?.taxDatas} dynamicField='tax' required={false} />
              </Box>

              {differences.taxName && previousValues.taxName && (
                <Tooltip title={`Old value: ${previousValues.taxName}`}>
                  <IconButton>
                    <InfoIcon color="secondary" />
                  </IconButton>
                </Tooltip>
              )}
            </Box>

          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            {userInfo?.userType === 1 ? <></> : <>
              {/* <Box display='flex' justifyContent='space-between' alignItems='center'>
                <Box sx={{ width: '60%' }}>
                  <DateForm label='Registration Date' dynamicField='companyRegistrationDate'
                    control={control} errors={errors} required={false} />
                </Box>
                <Box sx={{ width: '30%' }}>
                  <TextForm label='Credit Days' dynamicField='creditDays' type='number'
                    control={control} errors={errors}
                    required={false} disabled={false}
                    minValue={0} maxValue={90}
                  />
                </Box>
              </Box>
              <Box mt={1.5}>
                <TextForm label='Other Products' dynamicField='otherProducts'
                  control={control} errors={errors}
                  required={false} disabled={false}
                  min={3} max={50}
                />
              </Box>
              <Box mt={1.5}>
                <RadioVendorSupplier label='Payment Agreement' control={control}
                  errors={errors} dynamicField='_60DaysPayment' />
              </Box> */}

              <Box display='flex'>
                <Box flexGrow={1}>
                  <DateForm label='Registration Date' dynamicField='companyRegistrationDate'
                    control={control} errors={errors} required={false} />
                </Box>

                {differences.companyRegistrationDate && previousValues.companyRegistrationDate && (
                  <Tooltip title={`Old value: ${previousValues.companyRegistrationDate}`}>
                    <IconButton>
                      <InfoIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </>}
          </Grid>
        </Grid>
      </form>


      <Grid item xs={12} sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', mt: 1, mb: 2 }}>
        <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="div">
          RFQ Information
        </Typography>
        <Divider textAlign="left" sx={{ width: '92%' }}></Divider>
      </Grid>

      <Box sx={{ height: 400, width: '100%' }}>
        <VendorRFQ vendorCode={data?.data?.header?.vendorCode} />
      </Box>

      <SaveDialog text='Vendor Card' handleSave={handleSubmit(onSubmit)} />
      <ApproveDialog />
      <HoldDialog />
      <RejectDialog />
      <LogDialog />
    </>
  )
}


const columns1 = [
  dataColumn('businessCategoryName', 'Name', 300),
];

const columns2 = [
  dataColumn('userName', 'User Name', 190),
  dataColumn('fullName', 'User Full Name', 150),
  dataColumn('description', 'Position', 150),
  dataColumn('status', 'User Status', 80),
  dataColumn('phoneNumber', 'Contact Phone', 150),];

